import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const InstitucionalPage = lazy(() => import('../pages/institucional/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const PrevencaoIncendioPage = lazy(() => import('../pages/servicos/prevencao-incendio/page'));
const SegurancaTrabalhoPage = lazy(() => import('../pages/servicos/seguranca-trabalho/page'));
const AvaliacoesPericiasPage = lazy(() => import('../pages/servicos/avaliacoes-pericias/page'));
const TreinamentosPage = lazy(() => import('../pages/treinamentos/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/[slug]/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PoliticaPrivacidadePage = lazy(() => import('../pages/politica-privacidade/page'));
const TermosUsoPage = lazy(() => import('../pages/termos-uso/page'));
const ObrigadoPage = lazy(() => import('../pages/obrigado/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/institucional',
    element: <InstitucionalPage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/servicos/prevencao-incendio',
    element: <PrevencaoIncendioPage />,
  },
  {
    path: '/servicos/seguranca-trabalho',
    element: <SegurancaTrabalhoPage />,
  },
  {
    path: '/servicos/avaliacoes-pericias',
    element: <AvaliacoesPericiasPage />,
  },
  {
    path: '/treinamentos',
    element: <TreinamentosPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/politica-privacidade',
    element: <PoliticaPrivacidadePage />,
  },
  {
    path: '/termos-uso',
    element: <TermosUsoPage />,
  },
  {
    path: '/obrigado',
    element: <ObrigadoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;